import { Box, SearchField, Text } from '@factorialco/deprecated-design-system'
import orderBy from 'lodash/orderBy'

import { observer } from 'mobx-react'

import ScrollableList from 'modules/core/components/ScrollableList'
import { useDebouncedSearch } from 'modules/core/hooks/useSearch'
import i18n from 'modules/core/lib/i18n'

import type Policy from 'modules/payroll_bundle/store/models/Policy'
import type PolicyPeriod from 'modules/payroll_bundle/store/models/PolicyPeriod'

interface Props {
  policyPeriodSelectedId: string
  policyPeriods: PolicyPeriod[]
  policy: Policy
  onChange: (policyPeriodId: string) => void
}

const PolicyPeriodPopoverContent = ({
  policyPeriods,
  policy,
  policyPeriodSelectedId,
  onChange,
}: Props) => {
  const { search, onSearch } = useDebouncedSearch()
  const filteredPolicyPeriods = policyPeriods.filter((policyPeriod) =>
    policyPeriod.attributes.name.toLowerCase().includes(search)
  )

  const isFilterPolicyPeriodsEmpty = filteredPolicyPeriods.length === 0

  return (
    <Box
      paddingBottom="s12"
      paddingX="s24"
      paddingTop="s24"
      aria-label={i18n.t(
        'payroll_bundle.payroll_policy.policy_period_selector.popover_selector_label'
      )}
    >
      <Box
        border={{ all: { color: 'grey200', width: 's1', style: 'solid' } }}
        borderRadius={{ all: 'abs008' }}
      >
        <Box width="full" background="grey200" padding="s8">
          <SearchField
            variant="big"
            search={search}
            onSearch={onSearch}
            placeholder={i18n.t('common.search')}
          />
        </Box>
        {isFilterPolicyPeriodsEmpty && (
          <Box alignItems="center" justifyContent="center" padding="s24">
            <Text.Normal>
              {i18n.t('payroll_bundle.payroll_policy.policy_period_selector.no_results')}
            </Text.Normal>
          </Box>
        )}

        {!isFilterPolicyPeriodsEmpty && (
          <ScrollableList>
            <Box
              aria-label={i18n.t(
                'payroll_bundle.payroll_policy.policy_period_selector.popover_policy_period_list_label'
              )}
            >
              {orderBy(
                filteredPolicyPeriods,
                (policyPeriod) => policyPeriod.get('starts_on'),
                'desc'
              ).map((policyPeriod) => {
                const isHighlighted = policyPeriodSelectedId === policyPeriod.attributes.id

                return (
                  <Box
                    justifyContent="center"
                    alignItems="flexStart"
                    padding="s16"
                    key={policyPeriod.id}
                    cursor="pointer"
                    onClick={() => onChange(policyPeriod.id)}
                    background={isHighlighted ? 'viridian100' : undefined}
                  >
                    <Text
                      size="300"
                      weight="medium"
                      color={isHighlighted ? 'viridian1200' : 'grey800'}
                    >
                      {policyPeriod.attributes.name.replace(policy.attributes.name, '')}
                    </Text>
                  </Box>
                )
              })}
            </Box>
          </ScrollableList>
        )}
      </Box>
    </Box>
  )
}

export default observer(PolicyPeriodPopoverContent)
